import tz from "tz-lookup";
import { distanceIntervaled, timeIntervaled } from "./common/intervaled.js";
import { dayProgress } from "../helpers/time.js";

const MINIMUM_DISTANCE_INTERVAL_FOR_TIME_ZONE_UPDATE_METERS = 10000;
const MINIMUM_TIME_INTERVAL_FOR_LOCAL_TIME_UPDATE_MILLISECONDS = 1000;
const LOCALE = "en-US";

const timeZone = distanceIntervaled(
    MINIMUM_DISTANCE_INTERVAL_FOR_TIME_ZONE_UPDATE_METERS,

    ([$journey], set) => {
        const { location } = $journey;
        const timeZone = tz(location.latitude, location.longitude);

        set(timeZone);
    }
);

const localTime = timeIntervaled(
    MINIMUM_TIME_INTERVAL_FOR_LOCAL_TIME_UPDATE_MILLISECONDS,

    ([, $timeZone], set) => {
        if (!$timeZone) {
            return;
        }

        const formatted = new Date().toLocaleString(LOCALE, {
            timeZone: $timeZone
        });

        const date = new Date(formatted);

        set({
            formatted,
            date,
            progress: parseFloat(dayProgress(date).toFixed(3))
        });
    },
    [timeZone]
);

export default localTime;
